exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".compact-inbox-item[data-v-e9623e50] {\n  position: relative;\n  padding: 12px !important;\n}\n.compact-inbox-item[data-v-e9623e50]:hover {\n  cursor: pointer;\n}\n.compact-inbox-item p[data-v-e9623e50] {\n  margin: 0;\n  width: 92%;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.compact-inbox-item-checkbox[data-v-e9623e50] {\n  position: absolute;\n  right: 4px;\n  top: 8px;\n  display: flex;\n}\n.compact-action-buttons[data-v-e9623e50] {\n  position: absolute;\n  top: -1;\n  right: -1;\n}", ""]);

// exports
